import { render } from "./TransferList.vue?vue&type=template&id=433d456b&scoped=true&ts=true"
import script from "./TransferList.vue?vue&type=script&lang=ts"
export * from "./TransferList.vue?vue&type=script&lang=ts"

import "./TransferList.vue?vue&type=style&index=0&id=433d456b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433d456b"]])

export default __exports__